import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';

@Component({
  selector: 'app-placeholder-page',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './placeholder-page.component.html',
  styleUrls: ['./placeholder-page.component.scss']
})
export class PlaceholderPageComponent {
  private readonly route = inject(ActivatedRoute);
  readonly title = this.route.snapshot.data['title'] as string;
  readonly state = history.state as {
    registrationNo?: string;
    stakeholderType?: string;
    submittedOn?: string;
    status?: string;
  };

  readonly registrationNo = this.state.registrationNo || 'N/A';
  readonly stakeholderType = this.state.stakeholderType || this.title.replace(' Registration Submitted', '');
  readonly submittedOn = this.state.submittedOn || new Date().toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
  readonly status = this.state.status || 'Pending Admin Review';
}
